<template>
  <table class="seasons-table table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col">Сезон</th>
        <th scope="col">Название</th>
        <th scope="col">Прототип</th>
        <th scope="col">Статус</th>
        <th scope="col">Начало</th>
        <th scope="col">Конец</th>
        <th scope="col" v-if="isActionsColumnVisible">Действия</th>
      </tr>
    </thead>
    <tr
      v-for="season in seasons"
      :key="season.seasonId"
    >
      <td>
        <season-link :seasonId="season.seasonId" label="сезон"/>
      </td>
      <td class="season-type-name">
        {{getSeasonTypeName(season.seasonProtoId)}}
      </td>
      <td>
        {{ season.seasonProtoId | getProtoAlias }}
      </td>
      <td :class="getSeasonStatusClass(season.status)">
        {{ season.status | getSeasonStatusName}}
      </td>
      <td>
        {{ season.stime | getMomentStr }}
      </td>
      <td>
        {{ season.ftime | getMomentStr }}
      </td>
      <td v-if="isActionsColumnVisible" class="action-box">
        <b-button
          v-if="isFinishButtonVisible(season.status)"
          @click="finishSeason(season)"
          variant="warning"
          size="sm"
        >
          Finish
        </b-button>
      </td>
    </tr>
  </table>
</template>

<script>
import auth from '../auth.js';

import { isSeasonActive                               } from '../model/season.js';
import { getSeasonStatusNameRu as getSeasonStatusName } from '../model/season.js';
import { getSeasonStatusClass                         } from '../model/season.js';
import { getSeasonTypeNameFromMap                     } from '../model/season.js';

import { mayManage } from '../util.js';

import SeasonLink from './SeasonLink.vue';

export default {
  name: 'PlayerSeasonsTable',

  components: {
    SeasonLink,
  },

  data() {
    return {
      actor: auth.getViewer(),
    };
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    seasons: {
      type: Array,
      required: true,
    },

    seasonTypeNameMap: {
      type: Map,
      required: true,
    },
  },

  computed: {
    /** @returns {boolean} */
    isActionsColumnVisible() {
      if(!this.mayManage) {
        return false;
      }

      return this.hasSeasonToFinish;
    },

    /** @returns {boolean} */
    mayManage() {
      return mayManage(this.actor.role);
    },

    /** @returns {boolean} */
    hasSeasonToFinish() {
      return this.hasActiveSeason;
    },

    /** @returns {boolean} */
    hasActiveSeason() {
      for(const season of this.seasons) {
        if(isSeasonActive(season.status)) {
          return true;
        }
      }
      return false;
    },
  },

  methods: {
    getSeasonStatusClass,

    getSeasonTypeName(seasonProtoId) {
      return getSeasonTypeNameFromMap(this.seasonTypeNameMap, seasonProtoId);
    },

    isFinishButtonVisible(status) {
      if(!this.mayManage) {
        return false;
      }
  
      return isSeasonActive(status);
    },

    finishSeason(season) {
      this.$emit('season-finish-requested', season);
    },
  },

  filters: {
    getSeasonStatusName,
  },
}
</script>

<style scoped>
.seasons-table {
  width: 1px;
}

.season-type-name {
  font-weight: bold;
}

.action-box {
  padding: 7px;
  vertical-align: middle;
}

.action-box > .btn:last-child {
  margin-right: 0 !important;
}
</style>
